module.exports = __webpack_public_path__ + "img/07.8d6abcf6.png";